import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import '../../assets/js/scripts.js';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['../../assets/sass/checkout/checkout.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckoutComponent implements OnInit {
  constructor(
    private breadcrumbsService: BreadcrumbsService,
  ) {}

  ngOnInit() {
    this.breadcrumbsService.translateBreadcrumb(
      '/checkout',
      'Serwery'
    );

    this.breadcrumbsService.translateBreadcrumbWithRegex(
      '/vm',
      'Serwery wirtualne'
    );
    
    this.breadcrumbsService.translateBreadcrumbWithRegex(
      '/checkout/select',
      'Lista konfiguracji'
    );
    
    this.breadcrumbsService.translateBreadcrumb(
      '/checkout/summary',
      'Podsumowanie'
    );
    this.breadcrumbsService.translateBreadcrumb(
      '/checkout/payment',
      'Płatność'
    );
    this.breadcrumbsService.translateBreadcrumb(
      '/checkout/company',
      'Wybór firmy'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts